// extracted by mini-css-extract-plugin
module.exports = {"FocusContainer":"FocusContainer_FocusContainer__8ZHFz"};